import { useTranslation } from "react-i18next";
import { useContent } from "../../i18n/useContent";
import Icon from "../ui/Icons";
import "./EmailButton.css";

export default function EmailButton() {
  const { contact } = useContent();
  const { t } = useTranslation();
  const href = `mailto:${contact.email}?subject=${encodeURIComponent(contact.emailSubject)}`;

  return (
    <div className="email-dock">
      <a href={href} className="email-fab" aria-label={t("a11y.emailUs", { email: contact.email })}>
        <Icon name="mail" size={26} />
      </a>
    </div>
  );
}
